<script setup lang="ts">
import EventStatusName from '@desktop/views/Relation/components/RelationView/EventStatusName.vue'
import MainSummary from '@desktop/views/Relation/components/RelationView/Main/MainSummary/MainSummary.vue'
import ResultWithPopover from '@desktop/views/Relation/components/RelationView/Main/ResultWithPopover/ResultWithPopover.vue'
import SimpleEventClock from '@desktop/views/Relation/Sports/components/RelationView/Main/EventClock/SimpleEventClock.vue'
import LineupsModal from '@desktop/views/Relation/Sports/Rugby/components/Lineups/LineupsModal.vue'
</script>

<template>
  <MainSummary
    :modalOptions="{
      skins: true,
      lineups: LineupsModal,
    }"
  >
    <template #result>
      <ResultWithPopover />
    </template>
    <template #bottom>
      <EventStatusName />
      <div class="flex gap-x-6.5">
        <div class="flex w-full flex-row justify-end gap-2" />
        <SimpleEventClock />
        <div class="flex w-full flex-row justify-end gap-2" />
      </div>
    </template>
  </MainSummary>
</template>
